import Notification from 'rc-notification';
import { NOTIFICATION_NODE_STYLE } from 'constants/misc';


// eslint-disable-next-line import/no-mutable-exports
let notification = null;
const defaultInstanceConfig = { style: { zIndex: '9999' } };
// eslint-disable-next-line
Notification.newInstance(defaultInstanceConfig, n => notification = n);

export { notification };

export const defaultNoticeConfig = {
  duration: 4,
  closable: false,
  style: NOTIFICATION_NODE_STYLE,
  className: 'alert--colored right-up',
};
